import React, { 
    useState, 
    useEffect 
} from 'react'

import Navbar from '../../Components/Navbar/Navbar'
import dayjs from 'dayjs';
import toast from 'react-hot-toast';

import { 
    Layout,
    Col, 
    Row,
    Button,
    Form,
    Select,
    DatePicker,
    Table,
    InputNumber,
    Space,
} from 'antd';
import { 
    useNavigate, 
    useParams 
} from 'react-router-dom';
import { 
    ArrowBack,
  } from '@mui/icons-material';
import { UseGetRequest } from '../../Utils/api/ApiRequests'
import { usePostRequest } from '../../hooks/usePostRequest'
import { ProductOutlined } from '@ant-design/icons';

const { RangePicker } = DatePicker;
const { Option } = Select;
const { Item } = Form;

const AddReading = () => {
    const navigate = useNavigate()
    const { callPost, loading } = usePostRequest(()=>{
        navigate(-1)
    });
    const [isLoading, setIsLoading] = useState(false)
    const [isDisabled, setIsDisabled] = useState(true)
    const [meterDetails, setMeterDetails] = useState([])
    const [readingDetails, setReadingDetails] = useState([])
    const [propertyData, setPropertyData] = useState([])
    const [propertyId, setPropertyId] = useState('')
    const [addMeterForm] = Form.useForm();
    const { type } = useParams();
    async function fetchMeterReadingDetails(utility_type, id, meterValues) {
        setIsLoading(true)
        const response = await UseGetRequest("meter_readings/get_previous_readings", 
        {
            utility_type: utility_type, 
            property_id: id, 
            date_from: meterValues?.date_range ? meterValues?.date_range[0]?.format('YYYY-MM-DD') : '', 
            date_to: meterValues?.date_range ? meterValues?.date_range[1]?.format('YYYY-MM-DD') : '',
        });
        if(response?.data?.data.length !== 0) {
            const meter = response?.data?.data?.map((data) => ({
                id: data.id,
                trade_name: data.trade_name,
                business_name: data.business_name,
                previous_meter: data.previous_meter,
                current_meter: data.previous_meter,
                normal_consumption: data.normal_consumption,
                normal_fee: data.normal_fee,
                emergency_consumption: data.emergency_consumption,
                emergency_fee: data.emergency_fee,
                total_fee: data.total_fee,
            }))
            setMeterDetails(meter)
        } else {
            setMeterDetails([])
        }

        setIsLoading(false)
    }

    const customSpinner = <ProductOutlined style={{ fontSize: 24 }} spin />; // Custom spinner component
    const meterValues = addMeterForm.getFieldsValue();
    const values = Form.useWatch([], addMeterForm);
    useEffect(() => {
        addMeterForm.validateFields({
        validateOnly: true,
            }).then(() => {
                setIsDisabled(false)
            },
            () => {
                setIsDisabled(true)
            },
        );
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [values, addMeterForm, propertyId]);

    useEffect(() => {
        if(propertyId && meterValues?.date_range){
            fetchMeterReadingDetails(type,propertyId, meterValues)
        }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [propertyId, meterValues?.date_range]);

    const defaultColumnsAlfresco = [
        {
          title: 'Tradename',
          dataIndex: 'trade_name',
        },
        {
          title: 'Business Name',
          dataIndex: 'business_name',
        },
        {
          title: 'Previous Reading',
          dataIndex: 'previous_meter',
          align: 'right',
        },
        {
            title: 'Current Reading',
            dataIndex: 'current_meter',
            align: 'right',
            render: (_, record, index) => {
                return (
                    <InputNumber  
                        min={record.previous_meter} 
                        value={record.current_meter}
                        style={{ width: '100%' }} 
                        onChange={(e) => handleAddMeterDetails(index,"current_meter",e, record)}
                    />
                );
            },
        },
        {
            title: 'Normal Consumption',
            dataIndex: 'normal_consumption',
            align: 'right',
            render: (_, record, index) => {
                return (
                    <InputNumber 
                        style={{ width: '100%' }} 
                        value={record.normal_consumption.toFixed(2)}
                        onChange={(e) => handleAddMeterDetails(index, "normal_consumption", e)}
                    />
                );
            },
        },
        {
          title: 'Normal Fee',
          dataIndex: 'normal_fee',
          align: 'right',
          render: text => parseFloat(text).toFixed(2),
        },
        {
          title: 'Emergency Consumption',
          dataIndex: 'emergency_consumption',
          align: 'right',
          render: text => parseFloat(text).toFixed(2),
        },
        {
          title: 'Emergency Fee',
          dataIndex: 'emergency_fee',
          align: 'right',
          render: text => parseFloat(text).toFixed(2),
        },
        {
          title: 'Total Fee',
          dataIndex: 'total_fee',
          align: 'right',
          render: text => parseFloat(text).toFixed(2),
        },
    ];
    const handleAddMeterDetails = (key, name, e, data) => {
        if(name === "current_meter"){
            setMeterDetails(prevState => {
                const newState = [...prevState];
                newState[key] = { 
    
                    ...newState[key], 
                    [name]: e,
                    normal_consumption: e - data.previous_meter
    
                };
                return newState;
            });
        } else {
            setMeterDetails(prevState => {
                const newState = [...prevState];
                newState[key] = { 
    
                    ...newState[key], 
                    normal_consumption: e,    
                };
                return newState;
            });
        }
    };
    const generateReading = (meter_rates, meterValues) => {
        const meter_data = meter_rates?.map((meter) => {
            var normFee = parseFloat(meter.normal_consumption) * parseFloat(meterValues?.normal_rate || 0);
            var empCons = ((parseFloat(meter.current_meter) - parseFloat(meter.previous_meter)) - parseFloat(meter.normal_consumption));
            var empFee = (parseFloat(meterValues?.emergency_rate || 0) *  parseFloat(empCons));
            var totalFee = (parseFloat(normFee) + parseFloat(empFee));
    
            return {
                id: meter.id,
                business_name: meter.business_name || "",
                trade_name: meter.trade_name || "",
                previous_meter: meter.previous_meter || 0.00,
                current_meter: meter.current_meter || 0.00,
                normal_consumption: meter.normal_consumption || 0.00,
                normal_rate: meterValues?.normal_rate || 0.00,
                emergency_rate: meterValues?.emergency_rate || 0.00,
                date_from: meterValues?.date_range ? meterValues?.date_range[0]?.format('YYYY-MM-DD') : '',
                date_to: meterValues?.date_range ? meterValues?.date_range[1]?.format('YYYY-MM-DD') : '',
                normal_fee: (normFee && normFee >= 0) ? normFee : 0.00,
                emergency_consumption:  (empCons && empCons >= 0) ? empCons : 0.00,
                emergency_fee: (empFee && empFee >= 0) ? empFee : 0.00,
                total_fee: (totalFee && totalFee >= 0) ? totalFee : 0.00,
            };
        });
    
        return meter_data;
    };
    

    const reading_data = generateReading(meterDetails, meterValues)

    async function fetchPropertyData() {
        // setIsLoading(true)

        const response = await UseGetRequest("properties/get", {property_id: ''});
        if (response?.data) {
          setPropertyData(response?.data?.data);
        } else {
          setPropertyData([])
        }
    
        // setIsLoading(false);
    }

    async function fetchLastReading() {
        // setIsLoading(true)
        const response = await UseGetRequest("meter_readings/get_last_reading_by_property", {utility_type: type, property_id: propertyId});
        if (response?.data) {
            const details = response?.data?.data
            setReadingDetails(details);
            addMeterForm.setFieldsValue({
                date_range: [
                    dayjs(details.date_to, 'YYYY/MM/DD').add(1, 'day'),
                    undefined
                    // dayjs(details.date_to, 'YYYY/MM/DD'),
                ],
            });

        } else {
          setReadingDetails([])
        }
    
        // setIsLoading(false);
    }

    const disabledDate = current => {
        const dateToDisable = dayjs(readingDetails.date_to, 'YYYY/MM/DD').add(1, 'day');
        return current && current.isBefore(dateToDisable, 'day');
    };

    const handlePropertyType = (value) => {
        setPropertyId(value)
    };

      
    const handleAddReading = () => {
        try{  
    
            const data = {
                date_from: meterValues.date_range[0].format('YYYY-MM-DD'),
                date_to: meterValues.date_range[1].format('YYYY-MM-DD'),
                utility_type: type,
                normal_rate: meterValues.normal_rate || 0.00,
                emergency_rate: meterValues.emergency_rate || 0.00,

                tenant_id: reading_data.map((item)=>item.id),
                previous_meter: reading_data.map((item)=>item.previous_meter),
                current_meter: reading_data.map((item)=>item.current_meter),
                normal_consumption: reading_data.map((item)=>item.normal_consumption),
                normal_fee: reading_data.map((item)=>item.normal_fee),
                emergency_consumption: reading_data.map((item)=>item.emergency_consumption),
                emergency_fee: reading_data.map((item)=>item.emergency_fee),
                total_fee: reading_data.map((item)=>item.total_fee),
            }
            var finalValues = Object.entries(data).map(([key, value]) => ({
                key,
                value,
            }));

            callPost(
                "meter_readings/create", 
                finalValues,
                true,
            );
        }catch (error) {
          toast.error('Validation Failed:', error);
        };
    };

    useEffect(() => {
        fetchPropertyData();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if(propertyId){
            fetchLastReading();
        }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [propertyId]);

    return (
        <Layout className='page'>
            <Navbar/>
            <Layout className='content-container overflow-y'>
                <Row className='p-2'>
                    <Col span={24} className='header-container'>
                        <Space>
                            <ArrowBack className='cursor' onClick={() => navigate(-1)}/>
                            ADD READING
                        </Space>
                    </Col>
                </Row>
                <Row className='p-2'>
                    <Col span={24}>
                        <Form
                            form={addMeterForm}
                            layout="vertical"
                        >
                            <Row className='mx-3 responsive-inline responsive-width'>
                                <Col span={4} className='pe-4'>
                                    <Item
                                        label="Property"
                                        name="property"
                                        rules={[{ required: true, message: 'Please select a date from' }]}
                                        className='reading-input'
                                    >
                                       <Select 
                                            onChange={handlePropertyType} 
                                            placeholder="Select a property"
                                            showSearch
                                            filterOption={(input, option) =>
                                                option?.children?.toLowerCase().includes(input.toLowerCase())
                                            }
                                        >
                                        {propertyData.map((option, index) => (
                                            <Option key={index} value={option.id}>{option.name}</Option>
                                        ))}
                                    </Select>
                                    </Item>
                                </Col>
                                <Col span={7} className='pe-4'>
                                    <Item
                                        label="Date Range"
                                        name="date_range"
                                        rules={[{ required: true, message: 'Please select a date from' }]}
                                        className='reading-input'
                                    >
                                        <RangePicker  
                                            style={{width:'100%'}}
                                            placeholder={['Date From', 'Date To']}
                                            format={'YYYY/MM/DD'}
                                            disabledDate={disabledDate}
                                        />
                                    </Item>
                                </Col>
                                <Col span={4} className='pe-4'>
                                    <Item
                                        label="Normal Rate"
                                        name="normal_rate"
                                        rules={[{ required: true, message: 'Please enter your Normal Rate!' }]}
                                        className='reading-input'
                                    >
                                        <InputNumber 
                                            style={{width:'100%'}}
                                        />
                                    </Item>
                                </Col>
                                <Col span={4} className='pe-4'>
                                    <Item
                                        label="Emergency Rate"
                                        name="emergency_rate"
                                        // rules={[{ required: true, message: 'Please enter your Emergency Rate!' }]}
                                        className='reading-input'
                                    >
                                        <InputNumber 
                                            style={{width:'100%'}}
                                        />
                                    </Item>
                                </Col>
                                <Col span={2} className='pe-4 reading-btn' align='center'>
                                    <Item >
                                        <Button 
                                            type="primary" 
                                            disabled={isDisabled}
                                            onClick={() => handleAddReading()}
                                            loading={loading}
                                            // className='responsive-width'
                                        >
                                            Submit
                                        </Button>
                                    </Item>
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                </Row>
                <Row className='page-content'>
                    <Col span={24} className='responsive-overflow-auto'>
                        <Table
                            rowClassName={() => 'editable-row'}
                            bordered
                            dataSource={reading_data}
                            columns={defaultColumnsAlfresco}
                            loading={{
                                indicator: customSpinner, // Use custom spinner
                                spinning: isLoading, // Set spinning based on loading state
                              }}
                        />
                    </Col>
                </Row>
            </Layout>
        </Layout>
    )
}

export default AddReading
